<template>
    <div>
        <template v-if="history_attendance === true && attendance !== null">
            <div class="modal fade" id="view-attendanceModal" tabindex="-1" role="dialog" aria-labelledby="view-attendanceModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                        <form @submit.prevent="updateAttendanceCorrection(popupData.id, popupData.cdate)" id="attendance_correction">
                            <div class="modal-body view-attendance-popup p-0">
                                <div class="view-attendance-content">
                                    <div class="head clearfix">
                                        <div class="image-holder">
                                            <img :src="popupData.picture" alt="" />
                                            <span class="attandance-status absent"></span>
                                        </div>
                                        <div class="view-attendance-text">
                                            <h2> {{popupData.name}} </h2>
                                            <span class="department"> {{popupData.depName}} , {{popupData.cityName}} </span>
                                            <em class="italic"> {{popupData.date}} <span class="highlight-color"> ( {{popupData.attendanceHour}} worked ) </span> </em>
                                        </div>
                                        <span class="edit-attendance-icon">Edit</span>
                                    </div>
                                    <div class="content-inner p-5">
                                        <div class="attendance-correction mb-5">
                                            <label class="label block-label mb-2"> Time in </label>
                                            <div class="correction-time mb-3">
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeInHour" :id="`absentTimeInHour_${popupData.id}`">
                                                        <option value="">--</option>
                                                        <option v-for="start_time_hour in 12" :value="start_time_hour"> {{(start_time_hour < 10) ? '0'+start_time_hour : start_time_hour}} </option>
                                                    </select>
                                                </div>
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeInMinute" :id="`absentTimeInMinute_${popupData.id}`">
                                                        <option value="">--</option>
                                                        <option v-for="(start_time_minute,index) in 60" :value="index"> {{(index < 10) ? '0'+index : index}} </option>
                                                    </select>
                                                </div>
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeInAMPM" :id="`absentTimeInAMPM_${popupData.id}`">
                                                        <option value="">--</option>
                                                        <option value="AM"> AM </option>
                                                        <option value="PM"> PM </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <label class="label block-label mb-2"> Time Out </label>
                                            <div class="correction-time">
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeOutHour" :id="`absentTimeOutHour_${popupData.id}`">
                                                        <option value="">--</option>
                                                        <option v-for="start_time_hour in 12" :value="start_time_hour"> {{(start_time_hour < 10) ? '0'+start_time_hour : start_time_hour}} </option>
                                                    </select>
                                                </div>
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeOutMinute" :id="`absentTimeOutMinute_${popupData.id}`">
                                                        <option value="">--</option>
                                                        <option v-for="(start_time_minute,index) in 60" :value="index"> {{(index < 10) ? '0'+index : index}} </option>
                                                    </select>
                                                </div>
                                                <div class="correction-time-col">
                                                    <select class="form-control selectpicker custom-select2 selectpicker-popup" data-size="5" name="absentTimeOutAMPM" :id="`absentTimeOutAMPM_${popupData.id}`">
                                                        <option value="">--</option>
                                                        <option value="AM"> AM </option>
                                                        <option value="PM"> PM </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="popupData.todayEntry.length > 0">
                                            <div class="attendance-history mb-3" v-for="entry in popupData.todayEntry">
                                                <div class="attendance-history-inner">
                                                    <div class="attendance-history-box clearfix">
                                                        <span :class="`image-icon picture-${entry.id} fas fa-image`" @click="toggleImagePopup($event)"></span>
                                                        <p class="attendance-history-text">
                                                            {{entry.status}}
                                                            <span class="bold-text"> {{entry.time}} </span>
                                                            <span class="location">{{entry.location}}</span>
                                                        </p>
                                                    </div>
                                                    <div class="attendance-photo mt-3">
                                                        <img :src="entry.picture" alt=''/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="" v-else>
                                            <h1 class="text-danger"><b>{{popupData.name}}</b> has not marked their attendance yet.</h1>
                                        </div>
                                    </div>

                                </div>
                                <div class="text-right btn-holder p-3">
                                    <button type="submit" class="btn btn-primary active">Update</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div> <!-- Absentess End-->
                <div class="">
                    <div class="attendance-head-bar mb-3 clearfix">
                        <h2 class="float-left"> Attendance History </h2>
                        <companySettings></companySettings>
                        <router-link to="/uploadBulkAttendance" class="btn btn-primary active mr-2 float-right" v-if="attendance_bulk_upload == true"> Attendance bulk upload </router-link>
                    </div>
                    <div class="row mb-3 normal-ib-space top-widgets-row">
                        <div class="col-md-3 widgets-col">
                            <div class="payroll-counter-box attendance-counter-box">
                                <div class="top-box no-bg">
                                    <span class="title" v-if="attendance.totalEmployee > 0" title="7"> <em class="rollover">
                                         {{(attendance.presentEmployee / attendance.totalEmployee) * 100 | noDecimal}}% </em> </span>
                                    <span class="title" v-else title="0"> <em class="rollover"> 0% </em> </span>
                                    <p> Average Attendance </p>
                                </div>
                                <div class="foot-box"></div>
                            </div>
                        </div>
                        <div class="col-md-3 widgets-col">
                            <div class="payroll-counter-box attendance-counter-box">
                                <div class="top-box average-arival no-bg">
                                    <span class="title" v-if="attendance.averageTimeIn != 0" :title="attendance.averageTimeIn.date | time_AMPM"> <em class="rollover">{{attendance.averageTimeIn.date | timeFormat}} <sub> {{attendance.averageTimeIn.date | time_AMPM}} </sub> </em> </span>
                                    <span class="title" title="00:00" v-else>00:00</span>
                                    <p> Average Arrivals </p>
                                </div>
                                <div class="foot-box"></div>
                            </div>
                        </div>
                        <div class="col-md-3 widgets-col">
                            <div class="payroll-counter-box attendance-counter-box">
                                <div class="top-box no-bg">
                                    <span class="title" :title="attendance.averageHours"> <em class="rollover"> {{attendance.averageHours}} </em> </span>
                                    <p> Average Hours / Day </p>
                                </div>
                                <div class="foot-box"></div>
                            </div>
                        </div>
                        <div class="col-md-3 widgets-col">
                            <div class="payroll-counter-box attendance-counter-box">
                                <div class="top-box no-bg p-0 attendance-top-box">
                                    <div class="graph_title">
                                        <b>Attendance Breakdown</b>
                                    </div>
                                    <div id="graph_sm_attendance_breakdown" style="height:105px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="attendance-history-filters clearfix mb-3">
                        <div class="filters-col m-0 float-right">
                            <input type="text" id="customSearch" class="search form-control" placeholder="Search" name="search" v-model="search" @keyup="searchFilter()" />
                        </div>
                        <div class="filters-col w-20 float-left">
                            <select class="selectpicker custom-select2" @change="searchHistory($event)" v-model="dbc_value">
                                <option value="">All</option>
                                    <optgroup label="Departments">
                                        <option v-for="dep in attendance.departments" :key="dep.id" :value="`department-${dep.id}`">{{dep.name}}</option>
                                    </optgroup>
                                    <optgroup label="Branches">
                                        <option v-for="branch in attendance.branches" :key="branch.id" :value="`branch-${branch.id}`" >{{branch.name}}</option>
                                    </optgroup>
                                    <optgroup label="City">
                                        <option v-for="city in attendance.cities" :key="city.id" :value="`city-${city.id}`">{{city.name}}</option>
                                    </optgroup>
                            </select>
                        </div>
                        <div class="filters-col w-20 float-left" v-show="is_show == true">
                            <select class="selectpicker custom-select2" id="attendanceFilterByWskMonthsTo_mob" @change="searchHistory($event)" v-model="form.week_type">
                                <option value="this_week" :selected="attendance.week_type == 'this_week'">Last Week</option>
                                <option value="last_week" :selected="attendance.week_type == 'last_week'">Last 2 Weeks</option>
                                <option value="this_month" :selected="attendance.week_type == 'this_month'">Last Month</option>
                                <option value="last_month" :selected="attendance.week_type == 'last_month'">Last 2 Months</option>
                            </select>
                        </div>

                        <div class="filters-col calendar-col hide w-15 float-left">
                            <datepicker v-model="form.fromdate" id="fromDTPicker_mob" input-class="datepicker" :bootstrap-styling="true" :clear-button="true" placeholder="From" @selected="filterData()" format="dd/MM/yyyy" ></datepicker>
                        </div>
                        <div class="filters-col calendar-col hide w-15 float-left">
                            <datepicker v-model="form.todate" id="toDTPicker_mob" input-class="datepicker" :bootstrap-styling="true" :clear-button="true" placeholder="To" @selected="filterData()" format="dd/MM/yyyy" :disabledDates="disabledDatesTo"></datepicker>
                        </div>
                        <div class="filters-col open-calendar-main float-left">
                            <span class="open-calendar"></span>
                        </div>
                        <div class="filters-col hide cross-calendar-main float-left">
                            <span class="cross-calendar"></span>
                        </div>
                        <div class="float-left">
                            <button @click="exportHistory" class="btn btn-primary export">Export Attendance</button>
                        </div>

                    </div>
                    
                    <div class="total-work-days row normal-ib-space mb-3">
                        <div class="col">
                            <p> There were <span class="highlight-color"> {{attendance.workingDays}} work days </span> in this period. </p>
                        </div>
                    </div>
                    <table id="dt" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Name</th>
                                <th>City</th>
                                <th>Branch</th>
                                <th>Department</th>
                                <th>Lates</th>
                                <th>Absent</th>
                                <th>Actul Hours</th>
                            </tr>
                        </thead>
                        <tbody>

                        </tbody>
                    </table>
                </div>
        </template>
        <template v-else-if="history_attendance === true && attendance === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="history_attendance === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    function format ( d ) {
        var arrMonths =  d.months;
		var string = '';
		var arrDaily_status;
		var monthsVal = 0;
		string +='<div class="historyDetailsListing">';
		for(monthsVal; monthsVal < arrMonths.length; monthsVal++){
             arrDaily_status = d.months[monthsVal]["daily_status"];
             if(arrDaily_status){
                var count = arrDaily_status.length;
             }else{
                 var count = 0;
             }
				string += '<div class="singleItem mb-3 clearfix"><div class="monthHeading">'+d.months[monthsVal]["name"]+'</div>';
					for(var j=0; j < count; j++ ){
						var statusDiv;
						var holiday = '';
                        var last_item='';
                        var onClick = 'VueComponents.attendanceHistory.methods.attendanceViewPopup('+d.id+');';
						if(j == arrDaily_status.length-1){
							last_item= 'last';
						}
						if('date' in d.months[monthsVal]['daily_status'][j]){
                        onClick = 'VueComponents.attendanceHistory.methods.attendanceViewPopup('+ d.id +',\''+d.months[monthsVal]['daily_status'][j]['date']+'\');';
                        }
                        if (d.months[monthsVal]["daily_status"][j]["leave"] == "leave") {
                            holiday = 'leave';
                            onClick = '';
                        }
                        if (d.months[monthsVal]["daily_status"][j]["holiday"] == "holiday") {
                            holiday = 'holiday';
                            onClick = '';
                        }
                        if (d.months[monthsVal]["daily_status"][j]["status"] == "leave") {
                            statusDiv = d.months[monthsVal]["daily_status"][j]["leaveStatus"];
                        }
                        if(d.months[monthsVal]["daily_status"][j]["status"] == "holiday"){
                            statusDiv = '';
                        }
                        if(d.months[monthsVal]["daily_status"][j]["status"] == "absent"){
                            statusDiv = '<i class="fa  fa-times-circle"></i>';
                        }
                        if(d.months[monthsVal]["daily_status"][j]["status"] == "present"){
                            statusDiv = '<i class="fa fa-check-circle"></i>';
                        }
                        if(d.months[monthsVal]["daily_status"][j]["status"] == "L"){
                            statusDiv = '<i class="txt-late">L</i>';
                        }
                        if(d.months[monthsVal]["daily_status"][j]["status"] == "P"){
                            statusDiv = '<i class="txt-partial">P</i>';
                        }
						string += '<div class="day '+last_item+' '+holiday+' " onclick=" '+ onClick +' ">'+
									'<div class="day-bg">'+
										'<span class="txt-day">'+d.months[monthsVal]["daily_status"][j]["name"]+'</span>'+
										'<span class="txt-status">'+statusDiv+'</span>'+
										'<span class="fa txt-caption"><span class="tooltip-text"> '+d.months[monthsVal]["daily_status"][j]["caption"]+'</span></span>'+
									'</div>'+
					  			'</div>';
			}
			string +='</div>';
		}
		string +='</div>';
	    return string;
    }
    var myTable = null;
    var gThat = null;
    import companySettings from './companySettings';
    export default {
        components: {
            companySettings
        },
        data() {
            return {
                history_attendance: null,
                attendance_bulk_upload: null,
                attendance: null,
                dbc_value:'',
                is_show : true,
                form: new Form({
                    shift_id: null,
                    branch_id: null,
                    city_id: null,
                    department_id: null,
                    week_type: 'last_week',
                    fromdate: null,
                    todate: null
                }),
                search: null,
                popupData:{
                    todayEntry:[]
                },
                disabledDatesTo:{
                    to: new Date(),
                },
            };
        },
	    filters: {
            noDecimal: function(data){
                return parseInt(data).toFixed(0);
            },
            timeFormat: function(dateTime){
                return moment(dateTime).format('h:mm');
            },
            time_AMPM: function(time){
                var t =  moment(time).format('a');
                if(t=='am'){ return 'AM'; }
                if(t=='pm'){ return 'PM'; }
            }
        },
        updated(){
            this.disabledDatesTo.to = this.form.fromdate;
        },

        mounted() {
            gThat = this;
            this.$Progress.start();
            this.can('history_attendance|attendance_bulk_upload').then(result => {
                this.history_attendance = result.history_attendance;
                this.attendance_bulk_upload = result.attendance_bulk_upload;
            }).then(result => {
                if(this.history_attendance == true){
                     this.getAttendanceHistoryData();
                }else{
                    this.$Progress.finish();
                }
            });
            EventBus.$on('refreshAttendance', data => {
                this.getAttendanceHistoryData();
            });

        },
        methods: {
            toggleImagePopup(e){
                $(e.target).toggleClass('active');
                $(e.target).parents('.attendance-history-inner').find('.attendance-photo').slideToggle();
            },
            updateAttendanceCorrection(id, cdate){
                this.$Progress.start();
                var array = [];
                var absentTimeInHour = $('select#absentTimeInHour_'+id).val();
                var absentTimeInMinute = $('select#absentTimeInMinute_'+id).val();
                var absentTimeInAMPM = $('select#absentTimeInAMPM_'+id).val();
                var absentTimeOutHour = $('select#absentTimeOutHour_'+id).val();
                var absentTimeOutMinute = $('select#absentTimeOutMinute_'+id).val();
                var absentTimeOutAMPM = $('select#absentTimeOutAMPM_'+id).val();

                var _token = '{{csrf_token()}}';
                var date = moment(cdate).format('YYYY-MM-DD');

                if(absentTimeInHour == '' || absentTimeInMinute == '' || absentTimeInAMPM == '' || absentTimeOutHour == '' || absentTimeOutMinute == '' || absentTimeOutAMPM == ''){
                    if(absentTimeInHour != '' && absentTimeInMinute != '' && absentTimeInAMPM != ''){
                        array.push({id:id,absentTimeInHour:absentTimeInHour,absentTimeInMinute:absentTimeInMinute,absentTimeInAMPM:absentTimeInAMPM,absentTimeOutHour:absentTimeOutHour,absentTimeOutMinute:absentTimeOutMinute,absentTimeOutAMPM:absentTimeOutAMPM});
                        axios.post('api/updateAttendaceTimeInOut',{date:date,_token:_token,data:JSON.stringify(array)}).then(res => {
                            if(res.status == 200){
                                myTable.ajax.reload();
                                $('#view-attendanceModal').modal('hide');
                                this.showToastBox('success','Attendance setting has been updated');
                            }else{
                                this.showAlertBox('error','Some problem in your form data');
                            }
                            this.$Progress.finish();
                        }).catch(err => {
                            this.showAlertBox('error','Some problem in your form data');
                        });
                    }
                    if(absentTimeOutHour != '' && absentTimeOutMinute != '' && absentTimeOutAMPM != ''){
                        array.push({id:id,absentTimeInHour:absentTimeInHour,absentTimeInMinute:absentTimeInMinute,absentTimeInAMPM:absentTimeInAMPM,absentTimeOutHour:absentTimeOutHour,absentTimeOutMinute:absentTimeOutMinute,absentTimeOutAMPM:absentTimeOutAMPM});
                        axios.post('api/updateAttendaceTimeInOut',{date:date,_token:_token,data:JSON.stringify(array)}).then(res => {
                            if(res.status == 200){
                                myTable.ajax.reload();
                                $('#view-attendanceModal').modal('hide');
                                this.showToastBox('success','Attendance setting has been updated');
                            }else{
                                this.showAlertBox('error','Some problem in your form data');
                            }
                            this.$Progress.finish();
                        }).catch(err => {
                            this.showAlertBox('error','Some problem in your form data');
                        });
                    }
                }else{
                    array.push({id:id,absentTimeInHour:absentTimeInHour,absentTimeInMinute:absentTimeInMinute,absentTimeInAMPM:absentTimeInAMPM,absentTimeOutHour:absentTimeOutHour,absentTimeOutMinute:absentTimeOutMinute,absentTimeOutAMPM:absentTimeOutAMPM});
                    axios.post('api/updateAttendaceTimeInOut',{date:date,_token:_token,data:JSON.stringify(array)}).then(res => {
                        if(res.status == 200){
                            myTable.ajax.reload();
                            $('#view-attendanceModal').modal('hide');
                            this.showToastBox('success','Attendance setting has been updated');
                        }else{
                            this.showAlertBox('error','Some problem in your form data');
                        }
                        this.$Progress.finish();
                    }).catch(err => {
                        this.$Progress.finish();
                        this.showAlertBox('error','Some problem in your form data');
                    });
                }
            },

            attendanceViewPopup(userId,date){
                $(".selectpicker-popup").val('');
                $(".selectpicker-popup").selectpicker("refresh");

                gThat.$Progress.start();
                axios.post('api/getAttendancePopupHTML',{userId:userId,date:date})
                .then(res => {
                    gThat.$Progress.finish();
                    gThat.popupData = res.data;
                    $('#view-attendanceModal').modal('show');
                })
                .catch(err => {
                    gThat.$Progress.finish();
                    console.log(err);
                });

            },

            exportHistory(){

                this.$Progress.start();
                var formData = {
                    'branch_id': this.form.branch_id,
					'city_id': this.form.city_id,
					'department_id': this.form.department_id,
					'week_type': this.form.week_type,
                }
                if(this.form.todate != null){
                    formData.todate = this.form.todate;
                }
                if(this.form.fromdate != null){
                    formData.fromdate = this.form.fromdate;
                }
                axios.post('/api/exportAttendanceHistory', formData,{
					responseType: 'blob'
				})
				.then(res => {
                    this.$Progress.finish();
					if(res.status == 200){
						const url = URL.createObjectURL(new Blob([res.data], {
						type: 'application/vnd.ms-excel'
					}))

					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'attendanceHistory.xlsx')
					document.body.appendChild(link)
					link.click();
					}else{
						this.$Progress.fail();
						swal.fire({
							type: 'error',
							title: 'Error to load form data...'
						});
					}
				})
				.catch(err => {
					this.$Progress.fail();
					swal.fire({
						type: 'error',
						title: 'Error to load form data'
					});
				});
            },

            searchHistory(e){

                let that = this;
                    var value = e.target.value;
                    value = value.split('-');
                        switch(value[0]){
                            case 'branch':
                                that.form.branch_id = value[1];
                                that.form.city_id = that.form.department_id = '';
                            break;
                            case 'city':
                                that.form.city_id = value[1];
                                that.form.branch_id = that.form.department_id = '';
                            break;
                            case 'department':
                                that.form.department_id = value[1];
                                that.form.branch_id = that.form.city_id = '';
                            break;
                            default:
                                that.form.branch_id = '';
                                that.form.department_id = '';
                                that.form.city_id = '';
                        }
                        if(value[0]=='shift'){
                            that.form.shift_id = value[1];
                        }
                    that.getAttendanceHistoryData();
                    that.searchFilter();
            },

            searchFilter(){
                this.$Progress.start();
                myTable.draw();      
            },

            filterData(){
                
                let that = this;
                setTimeout(function (){
                    if(this.form.todate != null && this.form.fromdate == null){
                        this.showAlertBox('error','Please select from date first.');
                        this.form.todate = null;
                        return false;
                    }else if(this.form.todate != null && this.form.fromdate != null){
                        // moment(this.form.fromdate).format('DD/MM/YYYY');
                        this.form.fromdate = this.form.fromdate;
                        this.form.todate = this.form.todate;
                        that.getAttendanceHistoryData();
                        that.searchFilter();
                    }

                }.bind(this),300);
            },

            getAttendanceHistoryData(){
                this.$Progress.start();
                this.form.post('api/attendanceHistory')
                .then(res => {
                    if(res.status == 200){
                        this.attendance = res.data;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                }).then(res => {
                    $('.selectpicker').selectpicker();
                    this.dataTableData();
                    this.attendanceChart();
                    this.jqueryFunctions();
                    EventBus.$emit('attendanceObject', this.attendance);
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                });
            },

            jqueryFunctions(){
                let that = this;
                    $('.open-calendar').click(function(){
                        that.is_show = false;
                        that.form.week_type = '';
                        $(this).parent().siblings('.calendar-col').show();
                        $(this).parent().siblings(".filters-col:not(.cross-calendar-main)").removeClass('w-20').addClass('w-15');
                        $(this).parent().hide();
                        $(this).parent().siblings('.cross-calendar-main').show();
                    })
                    $('.cross-calendar').click(function(){

                        $(this).parent().siblings('.calendar-col').hide();
                        $(this).parent().siblings(".filters-col:not(.open-calendar-main)").removeClass('w-15').addClass('w-20');
                        $(this).parent().hide();
                        $(this).parent().siblings('.open-calendar-main').show();
                        that.form.week_type = 'last_week';
                        that.is_show = true;
                        
                    })
            },

            dataTableData(){

                var that = this;
                    myTable = $("#dt").DataTable({
                        sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                        processing: true,
					    serverSide: true,
					    ajax: {
                            "url": "api/getAttendanceHistoryUsers",
                            "type": "POST",
                            "data": function (d) {
                                d.department_id = that.form.department_id;
                                d.city_id = that.form.city_id;
                                d.branch_id = that.form.branch_id;
                                d.week_type = that.form.week_type;
                                d.fromdate = that.form.fromdate;
                                d.todate = that.form.todate;
                                d.search = that.search;
						    },
						"headers": window.axios.defaults.headers.common,
						"dataSrc": "records",
					},
                    deferRender: true,
                    columns: [
                            {
                                "className":      'details-control option-expander',
                                "orderable":      false,
                                "data":           null,
                                "defaultContent": '<span class="fa fa-plus"></span>'
                            },
                            { "data": "name" },
                            { "data": "city" },
                            { "data": "branch" },
                            { "data": "department" },
                            { "data": "lates" },
                            { "data": "absent" },
                            { "data": "actual_hours" }
                        ],
                        "columnDefs": [ 
                            { "orderable": false, "targets": [5 , 6 , 7] }
                        ],
                        order: [[1, 'asc']],
                        "initComplete": (settings, json) => {
                            $('#dt tbody').on('click', 'td.details-control', function () {
                                var tr = $(this).closest('tr');
                                var row = myTable.row( tr );
                                if ( row.child.isShown() ) {
                                    // This row is already open - close it
                                    row.child.hide();
                                    tr.removeClass('shown');
                                }
                                else {
                                    // Open this row
                                    row.child( format(row.data()) ).show();
                                    tr.addClass('shown');
                                }
                            });
                            //icon click code
                            $(".image-icon").click(function(){
                                $(this).toggleClass('active');
                                $(this).parents('.attendance-history-inner').find('.attendance-photo').slideToggle();
                            })
                            $(".edit-attendance-icon").click(function(){
                                $('.attendance-correction').fadeToggle();
                                $('.btn-holder').toggleClass('active');
                            })
                            this.$Progress.finish();
                        }

                    });



            },

            attendanceChart(){
                Highcharts.chart('graph_sm_attendance_breakdown', {
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: ''
                    },
                    plotOptions: {
                        pie: {
                            size:'150%',
                            innerSize: 50,
                            depth: 0,
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                    enabled: false
                            }
                        },
                        series: {
                            groupPadding: 0
                        }

                    },
                    credits: false,
                    legend: {
                            align: 'right',
                            verticalAlign: 'middle',
                            layout: 'vertical',
                            x: 0,
                            y: 0
                        },
                    series: [{
                        type: 'pie',
                        dataLabels: {
                                enabled: false
                            },
                        allowPointSelect: true,

                        data: [{
                                name: 'On Time',
                                y: this.attendance.onTimeEmployee,
                                color: '#50ae55'
                            }, {
                                name: 'Late',
                                y: this.attendance.lateEmployee,
                                color:'#4054b2'
                            }, {
                                name: 'Absent',
                                y: this.attendance.totalEmployee - this.attendance.presentEmployee,
                                color: '#eb401f'

                        }],
                        showInLegend: true
                    }]
                });
            },

        },

        destroyed: function() {
            EventBus.$off('refreshAttendance');
        },
    }
</script>
